import { define } from '../../define.js';
import { Icon } from './icon.js';
export * from './icon.js';
define('icon', Icon);
